export const lgcProductRecommender = 'lgc-product-recommender';
